import { ReportData } from 'src/app/models/sale-report.model';

export const POS_REPORTS_STATE_TOKEN = 'posReports';

export interface PosReportsStateModel {
  endOfDayReport: {
    isLoaded: boolean;
    isProcessing: boolean;
    data: ReportData | null;
  };
  reportRecipients: {
    isLoading: boolean;
    data: string[] | null;
    error: any | null;
  };
}
